import { useState } from 'react';

export default function CreditLimitModal({ isOpen, onClose, message, onRequestCredits }) {
  const [isRequested, setIsRequested] = useState(false);
  const [isRequesting, setIsRequesting] = useState(false);

  if (!isOpen) return null;

  const handleRequest = async () => {
    if (!onRequestCredits || isRequested || isRequesting) return;
    setIsRequesting(true);
    try {
      await onRequestCredits();
      setIsRequested(true);
    } catch (err) {
      alert('申請に失敗しました: ' + err.message);
    } finally {
      setIsRequesting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[170] bg-black/70 flex items-center justify-center p-4 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="w-full max-w-sm bg-gray-800 border border-red-500/50 rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200">
        <div className="p-6 text-center space-y-4">
          <div className="w-16 h-16 bg-red-900/30 border border-red-500/30 rounded-full flex items-center justify-center mx-auto mb-2">
            <span className="text-3xl">🚫</span>
          </div>

          <h2 className="text-xl font-bold text-white">クレジット上限到達</h2>

          <p className="text-sm text-gray-300 leading-relaxed">
            {message || 'クレジットを使い切りました。管理者に連絡してください。'}
          </p>

          <div className="pt-2 space-y-3">
            <button
              onClick={handleRequest}
              disabled={isRequested || isRequesting}
              className={`w-full font-bold py-3 rounded-xl transition-all shadow-lg active:scale-95 flex items-center justify-center gap-2 ${
                isRequested
                  ? 'bg-emerald-600/50 text-emerald-200 cursor-default'
                  : 'bg-indigo-600 hover:bg-indigo-500 text-white'
              }`}
            >
              {isRequesting ? '申請中...' : isRequested ? '✅ 申請済み' : '管理者に申請する'}
            </button>
            <button
              onClick={onClose}
              className="w-full bg-gray-700 hover:bg-gray-600 text-gray-300 font-bold py-3 rounded-xl transition-all active:scale-95"
            >
              閉じる
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
